import React, { useState } from "react";
import { HiDotsHorizontal } from "react-icons/hi";
import ReactPaginate from "react-paginate";
import { Modal, Button, Table, Form } from "react-bootstrap";
import "../css/pagination.css";

const SmsTableComp = ({ members, itemsPerPage, reloadTable }) => {
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  const handlePageClick = (event) => {
    const newPage = event.selected;
    setCurrentPage(newPage);
  };

  const offset = currentPage * itemsPerPage;
  const currentPageData = members.slice(offset, offset + itemsPerPage);

  const handleShow = (row) => {
    setSelectedRow(row);
    setShow(true);
  };

  return (
    <div>
      <Table striped bordered hover className="shadow">
        <thead>
          <tr>
            <th>Member No.</th>
            <th>Name</th>
            <th>Surname</th>
            <th>Cell</th>
            {/* <th>Card</th> */}
            <th>Category</th>
            <th>Card No</th>
            <th>Gender</th>
            <th>Reg Date</th>
          </tr>
        </thead>
        <tbody>
          {currentPageData.map((row, index) => (
            <tr key={index}>
              <td>
                <small>{row.mnumber}</small>
              </td>
              <td>
                <small>{row.name}</small>
              </td>
              <td>
                <small>{row.surname}</small>
              </td>
              <td>
                <small>{row.cell}</small>
              </td>
              {/* <td
                className={row.card === "Yes" ? "bg-success" : "bg-danger"}
              ></td> */}
              <td>
                <small>{row.type}</small>
              </td>
              <td>
                <small
                  className="badge"
                  style={{ background: "#3bc0c3", width: "100%" }}
                >
                  {row.tagid}
                </small>
              </td>
              <td>
                <small>{row.gender}</small>
              </td>
              <td>
                <small className="badg badge-warning">{row.date}</small>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ReactPaginate
        previousLabel={"previous"}
        nextLabel={"next"}
        breakLabel={"..."}
        pageCount={Math.ceil(members.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    </div>
  );
};
export default SmsTableComp;
